// France
export const locale = {
  lang: 'fr',
  data: {
    TRANSLATOR: {
      SELECT: 'choisissez votre langue',
    },
    SIDEBAR: {
      RIDES_CONFIG: 'Rides',
      RIDES_CONFIG_SETTINGS: 'Settings',
      RIDES_CONFIG_GUEST_PHONES: 'Guest phones',
      RIDES_CONFIG_PROVIDERS: 'Providers',
      FACE_VERIFICATION_CONFIG: 'Face verification',
    },
    PAGES: {
      CORPORATION_OFFICE_DETAIL: {
        TITLE: 'Détails du Bureau',
        BACK_BUTTON: 'Retour',
        TAB_OVERVIEW: 'Informations générales',
        TAB_USERS: 'Utilisateurs assignés',
        GENERAL_INFORMATION: 'Informations générales',
        ADDITIONAL_INFORMATION: 'Informations supplémentaires',
        CONTACT_PERSON: 'Personne de Contact',
        CONTACT_PHONE: 'Téléphone de Contact',
        CONTACT_EMAIL: 'Email de Contact',
        STATUS: 'Statut',
        COMMERCIAL_ADDRESS: 'Adresse Commerciale',
        CITY: 'Ville',
        POSTAL_CODE: 'Code Postal',
        LOADING: 'Chargement des informations du bureau...',
        LOADING_USERS: 'Chargement des utilisateurs...',
        ERROR: 'Erreur',
        USERS: 'Utilisateurs',
        USER_NAME: 'Nom',
        USER_EMAIL: 'Email',
        USER_PHONE: 'Téléphone',
        USER_CORPORATE_EMAIL: 'Email Professionnel',
        USER_PERSONAL_EMAIL: 'Email Personnel',
        USER_DNI: 'DNI',
        USER_DEPARTMENT: 'Département',
        USER_CORPORATE_PHONE: 'Téléphone Professionnel',
        USER_CONFIRMED: 'Confirmé',
        USER_ROLE: 'Rôle',
        OFFICE_CODE: 'Code Bureau',
        CORPORATION: 'Entreprise',
        CREATED_AT: 'Créé:',
        UPDATED_AT: 'Mis à jour:',
        NO_USERS: "Pas d'utilisateurs dans ce bureau",
        WAIIS_LINK: 'Afficher dans WAIIS',
        DELETE_USER: 'Supprimer',
        DELETE_CONFIRMATION:
          'Êtes-vous sûr de vouloir supprimer cet utilisateur?',
        DELETE_CONFIRM_BUTTON: 'Oui, supprimer',
        DELETE_CANCEL_BUTTON: 'Annuler',
        ACTIONS: 'Actions',
        EDIT_USER: "Modifier l'utilisateur",
        ADD_USER: 'Ajouter un utilisateur',
        REQUIRED_FIELDS: 'Champs obligatoires',
        OPTIONAL_FIELDS: 'Champs optionnels (au moins un requis)',
        NAME: 'Nom',
        SURNAME: 'Prénom',
        DEPARTMENT: 'Département',
        CORPORATE_EMAIL: 'Email professionnel',
        PERSONAL_EMAIL: 'Email personnel',
        DNI: 'DNI',
        CORPORATE_PHONE: 'Téléphone professionnel',
        PERSONAL_PHONE: 'Téléphone personnel',
        CONFIRMED: 'Confirmé',
        STATUS_PENDING: 'En attente',
        STATUS_REJECTED: 'Rejeté',
        STATUS_ACCEPTED: 'Accepté',
        STATUS_ACTIVE: 'Actif',
        STATUS_INACTIVE: 'Inactif',
        CANCEL: 'Annuler',
        SAVE_USER: "Enregistrer l'utilisateur",
        UPDATE_USER: "Mettre à jour l'utilisateur",
        WAIT: 'Attendre',
        UPLOAD_CSV: 'Télécharger CSV',
        UPLOADING: 'Téléchargement en cours...',
        LINK_USERS: 'Lier les utilisateurs',
        LINKING: 'Liaison en cours...',
        ERROR_REQUIRED_FIELD: 'Champ obligatoire',
        ERROR_INVALID_EMAIL: 'Email invalide',
        ERROR_MIN_LENGTH: 'Doit contenir au moins 2 caractères',
        ERROR_INVALID_FIELD: 'Champ invalide',
      },
    },
    MENU: {
      NEW: 'Nouveau',
      ACTIONS: 'Actes',
      CREATE_POST: 'Créer un nouveau Post',
      PAGES: 'Pages',
      FEATURES: 'Fonctionnalités',
      APPS: 'Applications',
      DASHBOARD: 'Tableau de Bord',
    },
    AUTH: {
      GENERAL: {
        OR: 'Ou',
        SUBMIT_BUTTON: 'Soumettre',
        NO_ACCOUNT: 'Ne pas avoir de compte?',
        SIGNUP_BUTTON: 'Registre',
        FORGOT_BUTTON: 'Mot de passe oublié',
        BACK_BUTTON: 'Back',
        PRIVACY: 'Privacy',
        LEGAL: 'Legal',
        CONTACT: 'Contact',
      },
      LOGIN: {
        TITLE: 'Créer un compte',
        BUTTON: 'Sign In',
      },
      FORGOT: {
        TITLE: 'Forgotten Password?',
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.',
      },
      REGISTER: {
        TITLE: 'Sign Up',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfuly registered.',
      },
      INPUT: {
        EMAIL: 'Email',
        FULLNAME: 'Fullname',
        PASSWORD: 'Mot de passe',
        CONFIRM_PASSWORD: 'Confirm Password',
        USERNAME: "Nom d'utilisateur",
      },
      VALIDATION: {
        INVALID: "{{name}} n'est pas valide",
        REQUIRED: '{{name}} est requis',
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
      },
    },
    HTTP_ERRORS: {
      FORBIDDEN: {
        TITLE: 'Accès refusé',
        MESSAGE: "Vous n'avez pas accès à cette ressource.",
        CONFIRM: 'Compris',
      },
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: "Nombre d'enregistrements sélectionnés: ",
        ALL: 'All',
        SUSPENDED: 'Suspended',
        ACTIVE: 'Active',
        FILTER: 'Filter',
        BY_STATUS: 'by Status',
        BY_TYPE: 'by Type',
        BUSINESS: 'Business',
        INDIVIDUAL: 'Individual',
        SEARCH: 'Search',
        IN_ALL_FIELDS: 'in all fields',
      },
      ECOMMERCE: 'éCommerce',
      CUSTOMERS: {
        CUSTOMERS: 'Les clients',
        CUSTOMERS_LIST: 'Liste des clients',
        NEW_CUSTOMER: 'Nouveau client',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Suppression du client',
          DESCRIPTION: 'Êtes-vous sûr de supprimer définitivement ce client?',
          WAIT_DESCRIPTION: 'Le client est en train de supprimer ...',
          MESSAGE: 'Le client a été supprimé',
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Supprimer les clients',
          DESCRIPTION:
            'Êtes-vous sûr de supprimer définitivement les clients sélectionnés?',
          WAIT_DESCRIPTION: 'Les clients suppriment ...',
          MESSAGE: 'Les clients sélectionnés ont été supprimés',
        },
        UPDATE_STATUS: {
          TITLE: 'Le statut a été mis à jour pour les clients sélectionnés',
          MESSAGE:
            'Le statut des clients sélectionnés a été mis à jour avec succès',
        },
        EDIT: {
          UPDATE_MESSAGE: 'Le client a été mis à jour',
          ADD_MESSAGE: 'Le client a été créé',
        },
      },
    },
    WAIIS: {
      FACE_VERIFICATION: {
        SETTINGS: {
          TITLE: 'Face verification',
          GENERAL_TITLE: 'General switch',
          KILL_SWITCH_WARNING: 'Emergency kill switch: when turned off, nobody is required to pass face verification.',
          ENABLED_LABEL: 'Face verification enabled',
          THRESHOLDS_TITLE: 'Rekognition thresholds',
          LIVENESS_THRESHOLD_LABEL: 'Liveness confidence threshold',
          LIVENESS_THRESHOLD_HINT: 'Number between 0 and 100 (decimals allowed)',
          SIMILARITY_THRESHOLD_LABEL: 'Similarity threshold',
          SIMILARITY_THRESHOLD_HINT: 'Number between 0 and 100 (decimals allowed)',
          REFERENCE_TITLE: 'Comparison reference',
          REFERENCE_TECALIS_LABEL: 'Tecalis selfie',
          REFERENCE_TECALIS_HINT: 'Always against the selfie Tecalis verified against the ID document',
          REFERENCE_ENROLLMENT_LABEL: 'Capture after near misses',
          REFERENCE_ENROLLMENT_HINT: 'First against the Tecalis selfie; after several near misses the liveness image is stored and later checks compare against it',
          ENROLLMENT_MIN_SIMILARITY_LABEL: 'Minimum similarity of a near miss',
          ENROLLMENT_MIN_SIMILARITY_HINT: 'Number between 0 and 100 (decimals allowed). A Tecalis selfie with no detectable face also counts',
          ENROLLMENT_ATTEMPTS_LABEL: 'Near misses to store the capture',
          ENROLLMENT_ATTEMPTS_HINT: 'Whole number between 1 and 10, counting all the user\'s trips',
          UPDATED_AT_LABEL: 'Last modified',
          DISABLE_CONFIRM_TITLE: 'Turn off face verification?',
          DISABLE_CONFIRM_TEXT: 'Nobody will be required to pass face verification until it is turned back on.',
          CONFIRM: 'Confirm',
          CANCEL: 'Cancel',
          SAVE: 'Save',
          SAVING: 'Saving...',
          SAVED: 'Settings saved',
          ERROR_TITLE: 'Error',
          ERROR_LOAD: 'Settings could not be loaded',
          ERROR_SAVE: 'Changes could not be saved',
          ERROR_FORBIDDEN: 'You do not have permission to perform this action',
          ACCEPT: 'Accept',
          VALIDATION: {
            REQUIRED: 'This field is required',
            INTEGER: 'The value must be an integer',
            RANGE: 'The value must be between 0 and 100',
            ATTEMPTS_RANGE: 'The value must be between 1 and 10',
          },
        },
      },
      RIDES_CONFIG: {
        SETTINGS: {
          TITLE: 'Ride settings',
          VTC_LABEL: 'VTC enabled',
          VTC_HINT: 'Controls global availability of VTC rides in the app',
          VTC_CONFIRM_TITLE: 'Are you sure?',
          VTC_DISABLE_TEXT: 'Disabling VTC will hide the request-ride button in the app for all users',
          VTC_ENABLE_TEXT: 'Enabling VTC will show the request-ride button in the app again',
          VTC_SAVED: 'VTC updated',
          CONFIRM: 'Confirm',
          CANCEL: 'Cancel',
          RIDE_PRODUCTS_ENABLED_LABEL: 'WAIIS products in estimates',
          RIDE_PRODUCTS_ENABLED_HINT: 'On: the WAIIS products are shown and, for each one, the cheapest provider. Off: the real product list of each visible provider is shown (e.g. for certifications).',
          COMMISSION_ENABLED_LABEL: 'Charge commission',
          COMMISSION_PERCENT_LABEL: 'Commission %',
          COMMISSION_PERCENT_HINT: 'Percentage between 0 and 100 (two decimals)',
          CANCELLATION_PENALTY_LABEL: 'Cancellation penalty %',
          CANCELLATION_PENALTY_HINT: 'Percentage between 0 and 100',
          REAL_FEE_ADJUSTMENT_LABEL: 'Real fee adjustment',
          REAL_FEE_ADJUSTMENT_HINT: 'Recalculate the penalty using the provider\'s real fee',
          REAL_FEE_ADJUSTMENT_ENABLED_AT_LABEL: 'Applies to rides created from',
          RECEIPT_ADJUSTMENT_LABEL: 'Receipt adjustment on completed rides',
          RECEIPT_ADJUSTMENT_HINT: 'Reconcile the difference against the amount charged when the provider receipt arrives',
          RECEIPT_ADJUSTMENT_ENABLED_AT_LABEL: 'Applies to rides created from',
          ADJUSTMENT_NEVER_ENABLED: 'Never enabled',
          SAVE: 'Save',
          SAVING: 'Saving...',
          SAVED: 'Settings saved',
          ERROR_TITLE: 'Error',
          ERROR_LOAD: 'Could not load settings',
          ERROR_SAVE: 'Could not save changes',
          ACCEPT: 'Accept',
          VALIDATION: {
            REQUIRED: 'This field is required',
            RANGE: 'Value must be between 0 and 100',
          },
        },
        GUEST_PHONES: {
          TITLE: 'Guest phones',
          EMPTY: 'No phones configured',
          TABLE: {
            PHONE_NUMBER: 'Phone number',
            ACTIVE: 'Active',
            ACTIONS: 'Actions',
          },
          ACTIONS: {
            ADD: 'Add',
            EDIT: 'Edit',
            DELETE: 'Delete',
            CANCEL: 'Cancel',
            SAVE: 'Save',
            ACCEPT: 'Accept',
          },
          MODAL: {
            CREATE_TITLE: 'New guest phone',
            EDIT_TITLE: 'Edit guest phone',
          },
          FORM: {
            PHONE_NUMBER: 'Phone number',
            PHONE_PLACEHOLDER: '+34600000000',
            PHONE_HINT: 'E.164 format: international prefix with + (e.g. +34600000000)',
          },
          VALIDATION: {
            PHONE_REQUIRED: 'Phone number is required',
            PHONE_FORMAT: 'Invalid format: use E.164 (+ and 7–15 digits)',
          },
          DELETE: {
            TITLE: 'Delete phone?',
            TEXT: '{{phone}} will be removed from the guest pool',
            CONFIRM: 'Yes, delete',
          },
          ERROR: {
            TITLE: 'Error',
          },
        },
        PROVIDERS: {
          TITLE: 'Providers and product mapping',
          RIDE_PRODUCTS: {
            TITLE: 'WAIIS products',
            HELP: 'These are the products the rider sees. Each provider maps one of its real products to every WAIIS product; the estimate shows the cheapest mapped provider.',
            ADD: 'Add WAIIS product',
            MOVE_UP: 'Move up',
            MOVE_DOWN: 'Move down',
            TABLE: {
              ORDER: 'Order',
              PRODUCT: 'Product',
              VISIBLE: 'Visible',
              ACTIONS: 'Actions',
            },
            MODAL: {
              NEW_TITLE: 'New WAIIS product',
              EDIT_TITLE: 'Edit WAIIS product',
              KEY: 'Key',
              KEY_HELP: 'Internal identifier in lowercase, digits and hyphens (e.g. go, premium-xl). It cannot be changed later.',
              DISPLAY_NAME: 'Name',
              IMAGE: 'Image',
              IMAGE_HELP: 'URL of the icon the rider sees',
              DESCRIPTION: 'Description',
              DESCRIPTION_HELP: 'Optional, per language. Only languages with text are stored.',
              VISIBLE: 'Visible',
            },
            VALIDATION: {
              KEY_REQUIRED: 'The key is required',
              KEY_FORMAT: 'Only lowercase letters, digits and hyphens (50 characters max)',
              DISPLAY_NAME_REQUIRED: 'The name is required',
            },
            CONFIRM: {
              DELETE_TITLE: 'Delete WAIIS product?',
              DELETE_TEXT: '"{{product}}" will be permanently deleted',
            },
            ERROR: {
              IN_USE: 'It cannot be deleted: there are still mappings pointing to it in {{providers}}',
            },
          },
          ROUTE: {
            TITLE: 'Sample route for product discovery',
            HELP: 'Providers only reveal their products when estimating a trip, and the catalog changes by city. Pick an origin and destination in the city you want to query: the route is saved for the whole team.',
            PICKUP: 'Origin',
            DROPOFF: 'Destination',
          },
          DISCOVER: {
            BUTTON: 'Discover provider products',
            ADD_TAG: 'Use this key: ',
            PLACEHOLDER: 'Type the key or discover the provider products',
            EMPTY: 'No products discovered yet',
            CAPACITY: '{{capacity}} seats',
            MAPPED_TO: 'Already mapped to {{product}}',
            MAPPED_HIDDEN: 'Mapped and hidden',
            REFRESH: 'Query the provider again',
            ROUTE_USED: 'Sample route: {{pickup}} → {{dropoff}}',
            NO_ROUTE: 'Set the sample route on the providers page to discover products',
            ERROR: {
              DISABLED: 'The provider is disabled on the server',
              UNAVAILABLE: 'The provider is not available right now',
              GENERIC: 'Provider products could not be discovered',
            },
          },
          ACTIONS: {
            ADD_PRODUCT: 'Add product',
            SAVE: 'Save',
            CANCEL: 'Cancel',
            ACCEPT: 'Accept',
            EDIT: 'Edit',
            DELETE: 'Delete',
          },
          FORM: {
            DISPLAY_NAME: 'Custom name',
            VISIBLE: 'Visible',
          },
          EMPTY: {
            PRODUCTS: 'This provider has no mapped products yet',
            RIDE_PRODUCTS: 'There are no WAIIS products configured',
          },
          TABLE: {
            PRODUCT_KEY: 'Provider product',
            RIDE_PRODUCT: 'WAIIS product',
            VISIBLE: 'Visible',
            ACTIONS: 'Actions',
          },
          MODAL: {
            NEW_PRODUCT: 'New product',
            EDIT_PRODUCT: 'Edit product',
            PRODUCT_KEY: 'Provider product',
            PRODUCT_KEY_HELP: 'Exact product name at the provider (e.g. UberX, Standard)',
            RIDE_PRODUCT: 'WAIIS product',
            RIDE_PRODUCT_PLACEHOLDER: 'Select a WAIIS product',
            VISIBLE: 'Visible',
          },
          VALIDATION: {
            PRODUCT_KEY_REQUIRED: 'Provider product is required',
            RIDE_PRODUCT_REQUIRED: 'WAIIS product is required',
          },
          CONFIRM: {
            DELETE_PRODUCT_TITLE: 'Delete product?',
            DELETE_PRODUCT_TEXT: '"{{product}}" will be permanently deleted',
          },
          ERROR: {
            TITLE: 'Error',
          },
          SUCCESS: {
            PROVIDER_SAVED: 'Provider saved',
          },
        },
      },
      MATCH_REVIEW: {
        DRIVER: 'Conducteur',
        PASSENGER: 'Passager',
        VERIFY: 'Vérifier',
        SELECT_DRIVER: 'Sélectionnez un conducteur',
        SELECT_PASSENGER: 'Sélectionnez un passager',
        DRIVER_DATA: 'Données du conducteur',
        PASSENGER_DATA: 'Données du passager',
        ROUTE_MAP: 'Carte de route',
        NO_DATA: 'Aucune donnée disponible',
        ENTER_ROUTINE_IDS:
          'Entrez les IDs de routine du conducteur et du passager pour voir les itinéraires sur la carte',
        LOADED: 'Chargé',
        USER: 'Utilisateur',
        DISTANCE: 'Distance',
        DURATION: 'Durée',
        PRICE: 'Prix',
        LOADING: 'Chargement',
        SHOW_HEXAGONS: 'Afficher les hexagones',
        SHOW_MAP_HEXAGONS: 'Afficher tous les hexagones de la carte',
        SHOW_POLYLINE: 'Voir la polyligne',
        ADD_DRIVER: 'Ajouter un conducteur',
        ADD_RIDER: 'Ajouter un passager',
        SELECT_ROUTINE: 'Cliquez ici pour ajouter une routine',
        NAME: 'Nom',
        LOCATIONS: 'Emplacements',
        ERROR_LOADING_ROUTE: 'Erreur lors du chargement de la route',
        SELECT_ROUTE_DETAILS: 'Sélectionnez une route pour voir les détails',
        COPY_PHP_PAYLOAD: 'Copier le payload PHP',
        COPIED: 'Copié',
        CENTER: 'Centrer',
        H3_RESOLUTION: 'Résolution H3',
        HEXAGON_POINTS: 'Points hexagone',
        SIGNIFICANT_POINTS: 'Points significatifs',
        ALL_POINTS: 'Tous les points',
        ERROR: 'Erreur',
        MAPS_LOAD_ERROR: 'Erreur lors du chargement de Google Maps',
        ENTER_DRIVER_ID: 'Veuillez entrer un ID de routine du conducteur',
        ENTER_PASSENGER_ID: 'Veuillez entrer un ID de routine du passager',
        ERROR_VERIFYING:
          'Erreur lors de la vérification de la routine {{type}}',
        PICKUP: 'Ramassage {{type}}',
        ORIGIN: 'Origine {{type}}',
        DROPOFF: 'Dépôt {{type}}',
        DESTINATION: 'Destination {{type}}',
        DRIVER_TEXT: 'conducteur',
        PASSENGER_TEXT: 'passager',
        COORDINATES: '{{lat}}, {{lng}}',
        H3_INDEX: 'Indice H3 (Rés {{res}})',
        LOADING_ROUTINE: 'Chargement de la routine...',
        UNKNOWN_ERROR: 'Erreur inconnue',
        SEARCH_RADIUS: 'Rayon de recherche',
        RADIUS_PLACEHOLDER: 'Rayon en mètres',
        FOUND: 'Trouvé',
        INTEREST_POINTS: "points d'intérêt",
        NO_POINTS_FOUND: "Aucun point d'intérêt trouvé dans le rayon spécifié",
        ERROR_FETCHING_POINTS:
          "Erreur lors de la récupération des points d'intérêt",
        SEARCH_INTEREST_POINTS: "Rechercher les points d'intérêt",
        CANCEL_SEARCH: 'Annuler la recherche',
        LOAD_FROM_FILE: 'Charger depuis un fichier',
        PROCESS_COMPLETE: 'Processus terminé',
        CONFIRM: 'Confirmer',
      },
    },
  },
};
